module.exports = __webpack_public_path__ + "static/img/mariposa_zurqui.c9a7f8e0.png";